# Theme variables injected by gulp
THEME_NAME = 'bogen'
angular.module('app.directives', [])
  .directive 'onErrorSrc', () ->
    return
      link: (scope, element, attrs) ->
        element.bind 'error', () ->
          if (attrs.src != attrs.onErrorSrc)
            attrs.$set('src', attrs.onErrorSrc)
            element.addClass('img-error')

  .directive 'scrollPage', ->
    restrict: 'A'
    link: (scope, element, attrs) ->
      element.on 'click', (e) ->
        e.preventDefault()
        offset = if element.hasClass('nav-link-page') then -50 else 0
        scrollPage = new SmoothScroll()
        scrollPage.animateScroll(document.querySelector($(this).attr('href')), 0, {updateURL: false, header: '.header', offset: offset, speed: 200, speedAsDuration: true})


  .directive "compareTo", () ->
    require: "ngModel"
    scope:
      confirmPassword: "=compareTo"
    link: (scope, element, attributes, modelVal) ->
      modelVal.$validators.compareTo = (val) ->
        return true unless val
        return val == scope.confirmPassword
      scope.$watch "confirmPassword", () ->
        modelVal.$validate()

  .directive 'exhibitorLogo', () ->
    return
      restrict: 'A'
      replace: true
      scope:
        data: '=exhibitorLogo'
      compile: (element, attrs) ->
        return (self, element, attrs) ->
          # Check if data exists
          if !self.data
            element.html('')
            return

          logo = self.data.logo || null
          exhibitor = self.data.exhibitor || null
          alt = exhibitor?.company || logo?.name || ''


          # If logo is null or empty, return nothing
          if !logo or logo == ''
            element.html('')
            return

          # Build image proxy URL with parameters
          imageUrl = '/image-proxy/' + logo.file + '?quality=80&format=webp&width=100&height=100&mode=contain'

          # If logo exists and exhibitor.id exists, return a->img
          if logo && exhibitor
            return element.html('<a href="/aussteller/' + exhibitor + '" class="logo logo-md-2"><img src="' + imageUrl + '" alt="' + alt + '"></a>')

          # If logo exists but no exhibitor.id, return div->img
          if logo
            return element.html('<div class="logo logo-md-2 ' + exhibitor + '"><img src="' + imageUrl + '" alt="' + alt + '"></div>')

          # Fallback - should not reach here
          element.html('')
